import { _ as _Symbol } from "./auth-service-tools512.js";
import { _ as _getRawTag } from "./auth-service-tools513.js";
import { _ as _objectToString } from "./auth-service-tools514.js";
var Symbol$1 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;
var nullTag = "[object Null]",
    undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;

function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

var _baseGetTag = baseGetTag;
export { _baseGetTag as _ };